import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from 'vee-validate/dist/locale/en.json'
import id from 'vee-validate/dist/locale/id.json'

en.messages['before_or_equal'] = 'The {_field_} must be a date before or equal to {_value_}';
en.messages['after_or_equal'] = 'The {_field_} must be a date after or equal to {_value_}';
en.messages['date_between'] = 'The {_field_} must be between {_value_}';
en.messages['date_in_month'] = 'The {_field_} must be within {_value_} months';
en.messages['gt'] = 'The {_field_} must be greater than or equal to {_value_}';
en.messages['phone'] = "The {_field_} field is not a valid phone number";
en.messages['is_not'] = "The {_field_} is not a {_value_}";
en.messages['password_format'] = "The {_field_} at least 6 characters combination of uppercase, lowercase and numbers";
en.messages['file_mimes'] = 'The {_field_} must be a file of type: {type}.';
en.messages['file_required'] = '{_field_} is required';
id.messages['before_or_equal'] = '{_field_} harus berupa tanggal sebelum atau sama dengan tanggal {date}';
id.messages['after_or_equal'] = '{_field_} harus berupa tanggal sesudah atau sama dengan tanggal {date}';
id.messages['date_between'] = '{_field_} harus berupa tanggal antara {date} dan {date2}';
en.messages['date_in_month'] = 'Maksimal {_field_} {_value_} bulan';
id.messages['gt'] = '{_field_} harus lebih besar dari {_value_}';
id.messages['phone'] = "{_field_} harus berupa nomor telepon yang benar";
id.messages['is_not'] = "{_field_} tidak boleh {_value_}";
id.messages['password_format'] = "{_field_} minimal 6 karakter kombinasi huruf besar, huruf kecil, dan angka";
id.messages['file_mimes'] = '{_field_} harus berupa tipe file: {type}';
id.messages['file_required'] = '{_field_} harus diisi';

Vue.use(VueI18n)

function loadLocaleMessages() {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = {
        ...locales(key),
        validation: ({ en, id }[locale] || {}).messages || {}
      }
    }
  })
  return messages
}

export default new VueI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || 'en',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  messages: loadLocaleMessages()
})
